export default __webpack_public_path__ + "static/media/White0000.910f83b2.png";